// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { _ } from "~/i18n";

// placeholder pro datum
const DATE_PH = "$DATE_TIME";
const TAGS = [
	"Make",
	"Model",
	DATE_PH,
	"ExposureTime",
	"FNumber",
	"ExposureBiasValue",
	"Flash",
	"FlashBias",
	"FocalLength",
	"FocalLengthIn35mmFilm",
	"ISOSpeed",
	"ISOSpeedRatings",
	"ExposureProgram",
	"MeteringMode",
	"Macro",
	"WhiteBalance",
];

// priorita prvni nejvyssi - posledni nejmensi
export const DATE_TAGS = [
	"DateTimeOriginal",
	"DateTimeDigitized",
	"DateTime"
];

export default class EXIF {
	/**
	 * @param {object} data datovy objekt
	 * @param {object} options
	 */
	constructor(data, options) {
		this._data = this._getData(data);
		this._options = options || {};
		this._ec = [];
		this._dom = {
			container: node("div")
		};

		this._build();
	}

	destroy() {
		JAK.Events.removeListeners(this._ec);
	}

	getContainer() {
		return this._dom.container;
	}

	getState() {
		return {};
	}

	_getData(data) {
		var dateTimePriority = Infinity;
		var dateTime = null;
		var nodes = [];

		Object.keys(data).forEach(function(key) {
			var item = data[key];
			var ind = TAGS.indexOf(item.name);

			if (ind != -1) {
				if (!nodes.filter(function (node) { return node.name === item.name }).length) {
					nodes.push({
						name: item.name,
						value: item.value,
						pos: ind
					});
				}
				return;
			}

			ind = DATE_TAGS.indexOf(item.name);

			if (ind != -1 && ind < dateTimePriority) {
				dateTime = {
					name: item.name,
					value: item.value
				};

				dateTimePriority = ind;
			}
		});

		if (dateTime) {
			var ind = TAGS.indexOf(DATE_PH);
			dateTime.isDate = true;
			dateTime.pos = ind;
			nodes.splice(ind, 0, dateTime);
		}

		// seradime
		return nodes.sort(function(a, b) {
			return a.pos - b.pos
		});
	}

	_build() {
		this._dom.container.classList.add("content-exif");

		if (this._data.length) {
			var title = node("p", { innerHTML:"<strong>" + _("detail.content.exif.title") + ":</strong> ", className: "title" });
			this._dom.container.appendChild(title);

			var table = node("table");
			var tbody = node("tbody");

			table.appendChild(tbody);

			this._data.forEach(function(item) {
				var name = item.name;
				var value = item.value;

				if (item.isDate) {
					value = this._formatTime(value);
					name = "DateTime";
				}

				var tr = node("tr");
				var firstCell = node("td", { innerHTML: _("detail.content.exif." + name) + ":", className: "text" });
				var secondCell = node("td", { innerHTML: Mapy.Util.escapeHTML(value) });

				tr.appendChild(firstCell);
				tr.appendChild(secondCell);
				tbody.appendChild(tr);
			}, this);

			this._dom.container.appendChild(table);
		}
	}

	_formatTime(timeStr) {
		timeStr = (timeStr || "").trim();

		var output = timeStr;
		var parts = timeStr.split(" ");

		if (parts.length == 2) {
			var dateParts = parts[0].split(":");

			if (dateParts.length == 3) {
				output = [dateParts[2], dateParts[1], dateParts[0]].join(". ") + " " + parts[1];
			}
		}

		return output;
	}
}
